import React, { useEffect, useState } from 'react'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { BsDatabaseFillX } from 'react-icons/bs'
import { accountingAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { enteredToTally } from '../../redux/features/serviceSlice'
import FilterReceipt from '../../components/user/finance/FilterReceipt'


const Receipts = () => {
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams()
    const { markService } = useSelector((state) => state.service)

    const handleEnteredToTally = (id) => {
        dispatch(enteredToTally(id))
    }

    useEffect(() => {
        accountingAxios.get('/v2/receipts', {
            params: {
                from_date: searchParams.get('from_date'),
                end_date: searchParams.get('end_date'),
                receipt_no: searchParams.get('receipt_no'),
                receipt_type: searchParams.get('receipt_type'),
                status: searchParams.get('status'),
                direction: searchParams.get('direction'),
                party_id: searchParams.get('party_id'),
                party_type: searchParams.get('party_type')
            }
        }).then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })
        // eslint-disable-next-line
    }, [searchParams.get('from_date'), searchParams.get('end_date'), searchParams.get('receipt_no'), searchParams.get('receipt_type'),
    // eslint-disable-next-line
    searchParams.get('status'), searchParams.get('direction'), searchParams.get('party_id'), searchParams.get('party_type'),
    ])

    const filterModal = () => {
        setModal({
            status: true,
            title: "Filter",
            content: <FilterReceipt setModal={setModal} />
        })
    }

    return (
        <div className="bills-list">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Receipts']}>
                {data[0] ? <TableFilter topRight={<button onClick={filterModal}>Filter</button>}>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Receipt No</th>
                                <th>Type</th>
                                <th>Direction</th>
                                <th>Party</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Mark</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index} >
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/receipt/${item?.uuid}`)}  >
                                        {item?.receipt_date ? new Date(item?.receipt_date).toDateString() : ''}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/receipt/${item?.uuid}`)}  >
                                        {item?.receipt_no}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/receipt/${item?.uuid}`)}  >
                                        {item?.receipt_type}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/receipt/${item?.uuid}`)}  >
                                        {item?.direction}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/receipt/${item?.uuid}`)}  >
                                        {item?.party?.type} / {item?.party?.id}, {item?.party?.name}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/receipt/${item?.uuid}`)}  >
                                        ₹ {item?.total_amount}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/receipt/${item?.uuid}`)}  >
                                        {item?.status}
                                    </td>
                                    <td style={{ cursor: 'pointer' }}>
                                        <input type='checkbox' checked={markService?.includes(item.uuid)} onClick={() => handleEnteredToTally(item.uuid)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableFilter>
                    : <SpinWithMessage icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading}
                        bottomContent={<>
                            <button onClick={filterModal}>Filter</button>
                        </>} />
                }
            </SinglePage>
        </div >
    )
}

export default Receipts